import { Pipe, PipeTransform } from '@angular/core';
import { StockColumn } from '../domain/models/PalletStock';
import { AuthGateway } from '../application/gateway/AuthGateway';
import { TranslateService } from '@ngx-translate/core';
import { Lang } from '../ui/util/langs';

@Pipe({
  name: 'stockColumn',
  pure: false
})
export class StockColumnPipe implements PipeTransform {

    constructor(private _authService: AuthGateway, public translate: TranslateService) {
    }

  transform(stockColumn: StockColumn | undefined | null): string {
    if(!stockColumn)
        return this.translate.instant('CommonLabels.NotAvailableLabel')

    let lang = Lang.ENGLISH;

    const profile = this._authService.getUser()
    if(profile)
    {
      lang = profile.lang;
    }else{
      lang = this.translate.currentLang;
    }

    switch(lang)
    {
      case Lang.ENGLISH:
        return stockColumn.columnName;
      case Lang.SPANISH:
        return stockColumn.columnNameEs;
      default:
        return stockColumn.columnName;
    }
  }

}
